<template>
  <div class="workorderHistoryPackageData">
    <div class="col-12 row text-center mx-0 table-responsive" style="">
      <b-table
        :items="workorderHistoryPackageDataItem"
        :fields="workorderHistoryPackageDataFields"
        sticky-header="480px"
        :no-border-collapse="true"
        @row-clicked="onRowClicked"
        class="workorderHistoryPackageData-table-detail table-row-click"
      >
        <template #cell(box_qty))="data">
          <div>
            {{ data.value.toLocaleString("en-US") }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "workorderHistoryPackageData",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      workorderHistoryPackageDataFields:
        "workorderHistoryPackageData/get_workorderHistoryPackageDataFields",
      workorderHistoryPackageDataItem:
        "workorderHistoryPackageData/get_workorderHistoryPackageDataItem",
      workorderHistoryTableStyle:
        "workorderHistoryPackageData/get_workorderHistoryTableStyle",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_rowClickData: "workorderHistoryData/set_rowClickData",
    }),
    onRowClicked(items, index, event) {
      let vm = this;
      let obj = {
        items: items,
        index: index,
        event: event,
      };
      vm.set_rowClickData(obj);
    },
  },
};
</script>

<style>
</style>
<style lang="scss">
.workorderHistoryPackageData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.workorderHistoryPackageData-table-detail th,
.workorderHistoryPackageData-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.workorderHistoryPackageData-table-detail td {
  font-size: 1rem;
}
.workorderHistoryPackageData-table-detail.table-row-click td {
  cursor: pointer;
}
.workorderHistoryPackageData-table-detail th:first-child,
.workorderHistoryPackageData-table-detail td:first-child {
  border-left: 1px solid;
}
.workorderHistoryPackageData-table-detail tr th:nth-child(1),
.workorderHistoryPackageData-table-detail tr td:nth-child(1) {
  width: 150px;
  min-width: 150px;
}
.workorderHistoryPackageData-table-detail tr th:nth-child(2),
.workorderHistoryPackageData-table-detail tr td:nth-child(2) {
  width: 260px;
  min-width: 260px;
}
.workorderHistoryPackageData-table-detail tr th:nth-child(3),
.workorderHistoryPackageData-table-detail tr td:nth-child(3) {
  width: 260px;
  min-width: 260px;
}
.workorderHistoryPackageData-table-detail tr th:nth-child(4),
.workorderHistoryPackageData-table-detail tr td:nth-child(4) {
  white-space: pre-line;
  width: 150px;
  min-width: 150px;
}
.workorderHistoryPackageData-table-detail tr th:nth-child(5),
.workorderHistoryPackageData-table-detail tr td:nth-child(5) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryPackageData-table-detail tr th:nth-child(6),
.workorderHistoryPackageData-table-detail tr td:nth-child(6) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryPackageData-table-detail tr th:nth-child(7),
.workorderHistoryPackageData-table-detail tr td:nth-child(7) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryPackageData-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.workorderHistoryPackageData-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.workorderHistoryPackageData-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>


// WEBPACK FOOTER //
// src/components/workorderHistoryPackageData.vue